import React, { useContext, useEffect, useState, useRef } from 'react';
import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png";
import PanInput from '../../../components/OtpInput/PanInput';
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';
import { verifyPan } from '../../../Utils/api';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import { getStorage, goBack, setStorage, isEmpty } from '../../../Utils/common';
import { regexPan } from '../../../Utils/formValidation';
import ContextDashboard from '../../../Context/ContextDashboard';
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import { ArrowLeft, IdCard } from "lucide-react";
const initialData = {
  monthlyIncome: "",
};

function PanDetails() {
  const [pan, setPan] = useState(["", "", "", "", "", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(getStorage("step_percent"));
  const { setps } = useContext(ContextDashboard);
  const inputRefs = useRef([]);
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);

  const navigate = useNavigate();
  const { message, setMessage, logout, handleEvent } = useContext(ContextDashboard);

  const submit = () => {
    let panData = pan?.join("").toUpperCase();

    if (!regexPan.test(panData)) {
      setMessage({ type: 'error', msg: "Please enter a valid PAN number" });
      return;
    }

    if (!formData.monthlyIncome) {
      setFormDataError({ ...formDataError, monthlyIncome: "Monthly income is required" });
      return;
    }

    const param = {
      event_name: "pancard_verification",
      pancard: panData,
      profile_id: getStorage("cust_profile_id") || "",
      monthly_income: formData.monthlyIncome,
    };

    setLoading(true);
    verifyPan(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setStorage("pancard", panData);
        setStorage("fullName", resp?.data?.Data?.full_name);
        setStorage("step_percent", resp?.data?.Data?.step_percentage);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setResponse(resp?.data);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
        handleEvent(getStorage('next_step'));
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setPan(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        setMessage({ type: 'error', msg: resp?.data?.Message });
      }
    });
  };

  const showSteps_ = () => {
    setToggle(!toggle);
  };

  useEffect(() => {
    if (!isEmpty(setps)) {
      checkStep(setps);
    }
  }, [setps]);

  function checkStep(data) {
    setProgressBar(data?.step_complete_percent);
    const steps = data?.step_stage - 1;
    if (data?.step_complete_percent === 100) {
      setToggle(false);
    }
    setShowSteps(steps);
  }

  const onChange = (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormDataError({ ...formDataError, [name]: "" });
  };

  const handleIncomeChange = (e) => {
    const { value } = e.target;

    if (/^\d{0,7}$/.test(value)) {
      setFormData({ ...formData, monthlyIncome: value });
      setFormDataError({ ...formDataError, monthlyIncome: "" });
    }
  };

  return (
    <>
      <ProgressBar value={`${progressBar}%`}>
        <div></div>
        <></>
      </ProgressBar><br />
      <BoxWrapper className="relative sm:bg-gray-100 w-full ">

        <div>


          <div className='   text-center inline-block mb-5 pointer border border-blue-500 rounded-lg px-6 py-1 group hover:bg-gray-100 hover:bg-blue-50 transition-all duration-300' onClick={() => goBack(navigate, "/my-dashboard/")}>
            <ArrowLeft size={18} className='inline w-4 mr-1 text-blue-600 group-hover:-translate-x-1 transition-all duration-300' />
            <span className='font-medium text-black text-blue-600 '>Back</span>
          </div>
        </div>

        <div className="formmainBox flex justify-center border-1 border-gray-400 rounded-lg">

          <div className="right bg-white py-5 px-2 sm:p-10 text-center rounded-lg">
            <div className="flex justify-center">
              <div className="relative">
                <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
                  <IdCard className="text-blue-600" size={28} />
                </div>

                <span className="absolute -left-5 top-1 w-1 h-1 rounded-full bg-blue-300"></span>
                <span className="absolute -left-2 -top-1 w-1 h-1 rounded-full bg-blue-300"></span>
                <span className="absolute -right-5 top-2 w-1 h-1 rounded-full bg-blue-300"></span>
                <span className="absolute -right-2 -top-1 w-1 h-1 rounded-full bg-blue-300"></span>
              </div>
            </div>
            <h2 className='font-bold text-center text-[#1B2A57]'>PAN Authentication <span className="text-orange-500" >*</span></h2>
            <p className="text-center text-gray-500 mt-2">Please enter your PAN Card number. Your identity is secure with us.</p>

            <FormWrapper>
              <Alert className="flex justify-center" setMessage={setMessage} message={message} />
              <div className="inputBox panBox">
                <PanInput
                  type="text"
                  setOtp={setPan}
                  otp={pan}
                  isDisable={false}
                  placeholder="-"
                  number={false}
                  inputRefs={inputRefs}
                  className="w-12 h-12 border rounded-lg text-center text-xl font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500"
                /><br /><br />

                <Input
                  label="Monthly Income *"
                  name="monthlyIncome"
                  error={formDataError?.monthlyIncome}
                  onChange={handleIncomeChange}
                  value={formData?.monthlyIncome}
                  required={true}
                  type="number"
                  placeholder="Enter your monthly income"
                />
              </div>

              <div className="  button m-auto">
                <Button className='' title="Continue" onClick={submit} loading={loading} />
              </div>
            </FormWrapper>
          </div>
        </div>
      </BoxWrapper>
    </>
  );
}

export default PanDetails;